import i18n from "./i18n";
import { marketLanguageMap } from "./marketLanguageMap";
import { __currentUser__ } from "../graphql/policies";
import { MarketType } from "../types/types";

let activeFeature: string | null = null;
let sessionLang: string | null = null;
let sessionMarket: MarketType;

export const setFeatureMarketLanguage = (
  feature: string,
  market: MarketType
) => {
  activeFeature = feature;
  sessionLang = marketLanguageMap[market] ?? "en";
  sessionMarket = market;
  console.log(feature, market)
  if (i18n.resolvedLanguage !== sessionLang) {
    i18n.changeLanguage(sessionLang);
  }
};

export const restoreFeatureLanguage = (feature: string) => {
  if (feature !== activeFeature) return;
  if (!sessionLang) return;
  
  if (i18n.resolvedLanguage !== sessionLang) {
    i18n.changeLanguage(sessionLang);
  }
};

export const clearFeatureLanguage = () => {
const user = __currentUser__();
  const defaultMarket = user?.afUserMarkets?.[0]?.market as
    | MarketType
    | undefined;

  const lang = defaultMarket
    ? marketLanguageMap[defaultMarket] ?? "en"
    : "en";

  if (i18n.resolvedLanguage !== lang) {
    i18n.changeLanguage(lang);
  }
};

export const getActiveFeature = () => activeFeature;

export const getSessionMarket = () => sessionMarket;